export default __webpack_public_path__ + "static/media/EngageForBriefings-BGImage.6590e5bf.jpg";